import React, { useState, useEffect } from "react";
import { Box, Typography, Button, MobileStepper } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import PrizeTargetVid from "./Features_Prize_Trending.mp4";
import FeaturesTrending from "./Features_Trending.mp4";
import RankingVid from "./Features_Ranking.mp4";

const news = [
  {
    title: "Price Target Insights",
    description:
      "Consolidating real time price target updates in a single, user-friendly page. Organized in a latest first format",
    video: PrizeTargetVid,
    path: "/prize_target_news",
  },
  {
    title: "Latest Trending News",
    description:
      "The Trending News from all relevant and noteworthy market trends in one centralized hub",
    video: FeaturesTrending,
    path: "/trending_news",
  },
  {
    title: "Analyst Recommendations",
    description:
      "All relevant analyst opinions and status changes into one streamlined view. Whether it’s a recommendation to Buy, Hold, or Sell, or updates on analyst ratings.",
    video: RankingVid,
    path: "/ranking_news",
  },
];

const HomepageHero = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = news.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) =>
      prevActiveStep === 0 ? maxSteps - 1 : prevActiveStep - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 3000); // Auto-scroll every 5 seconds
    return () => clearInterval(interval);
  }, []);

  const current = news[activeStep];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        padding: { xs: "40px 20px", md: "80px 120px" },
        backgroundColor: "#fff",
        minHeight: "50vh",
        gap: { xs: 2, md: 6 },
      }}
    >
      {/* Left Side Text Content */}
      <Box
        sx={{
          maxWidth: { xs: "100%", md: "45%" },
          textAlign: { xs: "center", md: "left" },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "2rem", md: "3.5rem" },
            fontWeight: 700,
            fontFamily: "'Work Sans', sans-serif",
            mb: 2,
            lineHeight: 1.2,
          }}
        >
          {current.title}
        </Typography>

        <Typography
          sx={{
            fontSize: "1.1rem",
            color: "#666",
            fontFamily: "'Work Sans', sans-serif",
            mb: 4,
          }}
        >
          {current.description}
        </Typography>

        <Box sx={{ display: "flex", gap: 2, justifyContent: { xs: "center", md: "flex-start" }, mb: { xs: 0, md: 0 } }}>
          <Button
            variant="contained"
            onClick={() => navigate(current.path)}
            sx={{
              textTransform: "none",
              fontSize: "1rem",
              borderRadius: "25px",
              padding: "10px 24px",
              backgroundColor: "#111",
              fontFamily: "'Work Sans', sans-serif",
              "&:hover": { backgroundColor: "#333" },
            }}
          >
            Explore Now
          </Button>
        </Box>

        <MobileStepper
          variant="dots"
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          sx={{ background: "transparent", justifyContent: "center", mt: 4 }}
          nextButton={
            <Button size="small" onClick={handleNext}>
              Next <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button size="small" onClick={handleBack}>
              <KeyboardArrowLeft /> Back
            </Button>
          }
        />
      </Box>

      {/* Right Side Video Preview */}
      <motion.div
        key={current.video}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        style={{ borderRadius: "20px", overflow: "hidden", width: "100%" }}
      >
        <Box
          sx={{
            width: "100%",
            height: { xs: "calc(100vw * 0.56)", md: "auto" },
          }}
        >
          <video
            autoPlay
            muted
            loop
            playsInline
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "20px",
            }}
          >
            <source src={current.video} type="video/mp4" />
          </video>
        </Box>
      </motion.div>
    </Box>
  );
};

export default HomepageHero;